import { InvoiceRepository } from "../../repositories/InvoiceRepository";
import {
  InvoiceOperationResult,
  InvoiceDataEntity,
} from "../../entities/InvoiceEntity";
import type { ApprovalAuditPayload } from "../../../../../shared/utils/reviewWorkflow";

/**
 * Create Zoho Invoice Use Case
 * Creates an invoice in Zoho Books
 */
export class CreateZohoInvoiceUseCase {
  constructor(private repository: InvoiceRepository) {}

  async execute(
    invoiceId: number,
    invoiceData: InvoiceDataEntity,
    pdfUrl: string,
    approvalAudit?: ApprovalAuditPayload,
  ): Promise<InvoiceOperationResult> {
    // Validate inputs
    // if (!invoiceId || invoiceId <= 0) {
    //   throw new Error("Valid invoice ID is required");
    // }

    // if (!invoiceData) {
    //   throw new Error("Invoice data is required");
    // }

    // if (!pdfUrl || pdfUrl.trim() === "") {
    //   throw new Error("PDF URL is required");
    // }

    // // Validate required invoice data
    // if (!invoiceData.customer_id || invoiceData.customer_id.trim() === "") {
    //   throw new Error("Customer ID is required");
    // }

    // if (!invoiceData.invoice_number || invoiceData.invoice_number.trim() === "") {
    //   throw new Error("Invoice number is required");
    // }

    // if (!invoiceData.line_items || invoiceData.line_items.length === 0) {
    //   throw new Error("At least one line item is required");
    // }

    return await this.repository.createZohoInvoice(
      invoiceId,
      invoiceData,
      pdfUrl,
      approvalAudit,
    );
  }
}
